export default __webpack_public_path__ + "static/media/icono-abstracto.e6f2b8d1.svg";